import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  standalone: true,
  selector: 'shared-pg-footer2',
  templateUrl: './pg-footer.component.html',
  styleUrls: ['./pg-footer.component.scss'],
})

export class PgFooterComponent implements OnInit {
  @Input() applicationVersion: string;
  @Input() swAppVersion: string;
  @Input() timeoutRemaining: number;
  timeoutCounterDisplayEnabled = false;

  constructor() { }

  ngOnInit(): void {
    this.timeoutCounterDisplayEnabled = environment.TimeoutCounterDisplayEnabled;
  }
}
